import Serializer from 'umg-ember-backend/serializers/application';

export default class UserSerializer extends Serializer {
  attrs = {
    person: 'personId',
  };
}
